import axios from 'axios';

axios.defaults.headers.common['Content-Type'] ='application/json';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector("meta[name~=_token]").getAttribute('content');
window.axios = axios
let app = require('./site-app-client').default();

app.$mount("#"+ "site-app");

window.__APP__ = app
